// extracted by mini-css-extract-plugin
export default {"root":"Loader_root__79gXp","svg":"Loader_svg__sl6rr","spin":"Loader_spin__a6Zpk"};